/// <reference path="jquery.blockUI.js" />
/// <reference path="trs.api.model-1.0.0.js" />


/*********************************************************************************/
/*   API Configuration                                                           */
/*********************************************************************************/
var overrideVerbs = false;
var majorVersion = "1";
var minorVersion = "0.0";

(function (jQuery, undefined) {
    var smapi = window.smapi = window.smapi || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof smapi.access === "undefined") {
        jQuery.extend(smapi, { access: {} });
    }

    /*********************************************************************************/
    /*   API Internal Support Methods                                                */
    /*********************************************************************************/
    function _execRequest(url, type, data, successHandler, containerHandler, failureHandler) {

        jQuery.ajax({
            url: url,
            type: type,
            data: data,
            dataType: 'json',
            contentType:   'application/json; charset=utf-8',
            headers: {
                "x-api-version": majorVersion //,
            },
            processData: false,
            crossDomain: true,
       
            xhrFields: {
                withCredentials: true
            },
            success: function (data, textStatus, jqXHR) {
                var container;

                // build the container if applicable
                if (containerHandler != null && containerHandler != undefined) {
                    // Custom Handler
                    container = containerHandler(data, textStatus, jqXHR);

                } else if (data && data.Status != null) {// && data.Payload != null) {
                    // Standard Implementation
                    container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                }

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Success Handler
                    successHandler(container, data, textStatus, jqXHR);

                } else if (container != null && container.Status == "validation") {
                    // Execute the Validations Handler
                    alert(sm.portal.utility.getResourceValue('Validations') + ': ' + container.ValidationTitle);
                    //if (failureHandler) {
                    //    failureHandler(null, sm.portal.utility.getResourceValue('Validations') + ': ' + container.ValidationTitle)
                    //}

                } else if (container != null && container.Status == "error") {
                    // Execute the Error Handler
                    alert(sm.portal.utility.getResourceValue('Errors') + ': ' + container.ValidationTitle);
                    //if (failureHandler) {
                    //    failureHandler(null, sm.portal.utility.getResourceValue('Errors') + ': ' + container.ValidationTitle)
                    //}
                }
            },
            error: function (jqXHR, exception) {
                if (failureHandler) {
                    failureHandler(jqXHR, exception);
                }
            }
        });
    }

    function _formatEntitySchemaDefinition(data) {

        var fieldArray = new Array();
        var relationshipArray = new Array();
        var rulesArray = new Array();

        for (var i = 0; i < data.Fields.length; i++) {
            var fieldData = data.Fields[i];
            fieldArray.push(new smapi.access.FieldModel({
                FieldName: fieldData.FieldName,
                DataLength: fieldData.DataLength,
                DataType: fieldData.DataType,
                DefaultValue: fieldData.DefaultValue,
                DisplayMask: fieldData.DisplayMask,
                FieldOrdinal: fieldData.FieldOrdinal,
                Hidden: fieldData.Hidden,
                InvalidMessage: fieldData.InvalidMessage,
                IsFixedLength: fieldData.IsFixedLength,
                IsHtml: fieldData.IsHtml,
                IsNullable: fieldData.IsNullable,
                IsPercentage: fieldData.IsPercentage,
                Label: fieldData.Label,
                MaximumValue: fieldData.MaximumValue,
                MinimumValue: fieldData.MinimumValue,
                Required: fieldData.Required,
                ShortLabel: fieldData.ShortLabel,
                Tooltip: fieldData.Tooltip
            }));
        }

        for (var i = 0; i < data.Relationships.length; i++) {
            var relData = data.Relationships[i];
            relationshipArray.push(new smapi.access.RelationshipModel({
                AttributeName: relData.AttributeName,
                DataLength: relData.DataLength,
                DataType: relData.DataType,
                BusinessMeaningName: relData.BusinessMeaningName,
                ForeignKeyName: relData.ForeignKeyName,
                Hidden: relData.Hidden,
                Label: relData.Label,
                Required: relData.Required,
                ShortLabel: relData.ShortLabel,
                Tooltip: relData.Tooltip,
                RelationshipType: relData.RelationshipType
            }));
        }

        // TODO: Rules Array Population

        var container = new smapi.access.ApiEntityDefinitionModel({
            Status: data.Status,
            ValTitle: data.ValidationTitle,
            ValMessages: data.ValidationMessages,
            Name: data.Name,
            Description: data.Description,
            GID: data.GID,
            Fields: fieldArray,
            Relationships: relationshipArray,
            Rules: rulesArray
        });

        console.log('Container Filled: %o', container);

        return container;
    }

    /*********************************************************************************/
    /*   API Entity List and Schema Methods                                          */
    /*********************************************************************************/
    function getEntityDefinition(baseUri, options) {

        var defaults = {
            requestedEntityName: '',
            successHandler: function (container) { },
            containerHandler: null,
            failureHandler: null
        };

        // Hydrate the settings with the submitted options
        var settings = jQuery.extend({}, defaults, options);

        // Set URI
        var uri = sm.portal.utility.formatString(baseUri + 'api/entitydefinition/get/{0}', 
            settings.requestedEntityName);

        // Execute the request
        smapi.access._execRequest(uri, 'GET', null, 
            settings.successHandler, 
            smapi.access._formatEntitySchemaDefinition, // unique response handler for container
            settings.failureHandler);

        // THIS ONE ISN'T WORKING YET - I've got a .Container. inline I didn't expect.

    }

    function getEntityList(baseUri, options) {

        var defaults = {
            filter: '',
            successHandler: function (container) { },
            containerHandler: null,
            failureHandler: null
        };

        // Hydrate the settings with the submitted options
        var settings = jQuery.extend({}, defaults, options);

        // Set the URI
        var uri = baseUri + 'api/entitydefinition/list/';

        // Execute the request
        smapi.access._execRequest(uri,
            'GET',
            settings.filter,
            settings.successHandler,
            settings.containerHandler,
            settings.failureHandler);

        //jQuery.ajax({
        //    url: uri,
        //    type: 'GET',
        //    data: filter,
        //    dataType: 'json',
        //    contentType: 'application/json; charset=utf-8',
        //    processData: false,
        //    crossDomain: true,
        //    xhrFields: {
        //        withCredentials: true
        //    },
        //    success: function (data) {

        //        var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

        //        if (container.Status == "success") {
        //            // Execute the Success Handler
        //            successHandler(container);

        //        } else if (container.Status == "validation") {
        //            // Execute the Validations Handler
        //            alert(sm.portal.utility.getResourceValue('Validations') + ': ' + container.ValidationTitle);

        //        } else if (container.Status == "error") {
        //            // Execute the Error Handler
        //            alert(sm.portal.utility.getResourceValue('Errors') + ': ' + container.ValidationTitle);

        //        }

        //    },
        //    error: function (jqXHR, exception) {
        //        //alert('Ajax-Error: ' + jqXHR.status);
        //    }
        //});
    }

    /*********************************************************************************/
    /*   API Standard CRUD+ Operation Methods                                        */
    /*********************************************************************************/
    function getList(baseUri, options) {

        var defaults = {
            requestedEntityName: '',
            recursionLevel: 0,
            maxRequestCount: 100,
            successHandler: function (container) { },
            containerHandler: null,
            failureHandler: null
        };

        // Hydrate the settings with the submitted options
        var settings = jQuery.extend({}, defaults, options);

        // Set the URI
        var uri = baseUri + sm.portal.utility.formatString('api/{0}/get/?recursionLevel={1}&maxRequestCount={2}',
            settings.requestedEntityName,
            settings.recursionLevel,
            settings.maxRequestCount);

        // Execute the Request
        smapi.access._execRequest(uri,
            'GET',
            null,
            settings.successHandler,
            settings.containerHandler,
            settings.failureHandler);
    }

    function search(baseUri, options) {

        var defaults = {
            requestedEntityName: '',
            config: '',
            criteria: '',
            recursionLevel: 0,
            successHandler: function (container) { },
            containerHandler: null,
            failureHandler: null
        };

        // Hydrate the settings with the submitted options
        var settings = jQuery.extend({}, defaults, options);

        // Set the URI
        var uri = baseUri + sm.portal.utility.formatString('api/{0}/get?config={1}&criteria={2}&recursionLevel={3}',
            settings.requestedEntityName,
            settings.config,
            settings.criteria,
            settings.recursionLevel);

        // Execute the request
        smapi.access._execRequest(uri,
            'GET',
            null,
            settings.successHandler,
            settings.containerHandler, 
            settings.failureHandler);   
    }

    function create(baseUri, options) {

        var defaults = {
            requestedEntityName: '',
            model: null,
            recursionLevel: 0,
            successHandler: function (container) { },
            containerHandler: null,
            failureHandler: null
        };

        // Hydrate the settings with the submitted options
        var settings = jQuery.extend({}, defaults, options);

        // Set the URI
        var uri = baseUri + sm.portal.utility.formatString('api/{0}/post?action=POST&id={1}&recursionLevel={2}',
            settings.requestedEntityName,
            settings.model.ID(),
            settings.recursionLevel);

        // Execute the request
        smapi.access._execRequest(uri,
            'POST',
            JSON.stringify(ko.mapping.toJS(settings.model)),
            settings.successHandler,
            settings.containerHandler,
            settings.failureHandler);
    }

    function getById(baseUri, options) {

        var defaults = {
            requestedEntityName: '',
            id: 0,
            recursionLevel: 0,
            successHandler: function (container) { },
            containerHandler: null,
            failureHandler: null
        };

        // Hydrate the settings with the submitted options
        var settings = jQuery.extend({}, defaults, options);

        // Set the URI
        var uri = baseUri + sm.portal.utility.formatString('api/{0}/get?id={1}&recursionLevel={2}',
            settings.requestedEntityName,
            settings.id,
            settings.recursionLevel);

        // Execute the request
        smapi.access._execRequest(uri,
            'GET',
            null,
            settings.successHandler,
            settings.containerHandler,
            settings.failureHandler);
    }

    function update(baseUri, options) {

        var defaults = {
            requestedEntityName: '',
            model: null,
            recursionLevel: 0,
            successHandler: function (container) { },
            containerHandler: null,
            failureHandler: null
        };

        // Hydrate the settings with the submitted options
        var settings = jQuery.extend({}, defaults, options);


        // Set the URI
        var uri = baseUri + sm.portal.utility.formatString('api/{0}/post?action=PUT&id={1}&recursionLevel={2}',
            settings.requestedEntityName,
            settings.model.ID(),
            settings.recursionLevel);

        // Execute the request
        smapi.access._execRequest(uri,
            'POST',
            JSON.stringify(ko.mapping.toJS(settings.model)),
            settings.successHandler,
            settings.containerHandler,
            settings.failureHandler);
    }

    function remove(baseUri, options) {

        var defaults = {
            requestedEntityName: '',
            id: 0,
            successHandler: function (container) { },
            containerHandler: null,
            failureHandler: null
        };

        // Hydrate the settings with the submitted options
        var settings = jQuery.extend({}, defaults, options);

        // Set the URI
        var uri = baseUri + sm.portal.utility.formatString('api/{0}/post?action=DELETE&id={1}',
            settings.requestedEntityName, 
            settings.id);

        // Execute the request
        smapi.access._execRequest(uri,
            'POST',
            null,
            settings.successHandler,
            settings.containerHandler,
            settings.failureHandler);
    }

    function polyPost(uri, action, options) {

        var defaults = {
            id: 0,
            model: null,
            recursionLevel: 0,
            successHandler: function (container) { },
            containerHandler: null,
            failureHandler: null
        };

        // Hydrate the settings with the submitted options
        var settings = jQuery.extend({}, defaults, options);

        var uri = sm.portal.utility.formatString(uri, action, settings.id, settings.recursionLevel);
        var submitData = action == "DELETE" ? null : JSON.stringify(ko.mapping.toJS(settings.model));

        smapi.access._execRequest(uri,
            'POST',
            submitData,
            settings.successHandler,
            settings.containerHandler,
            settings.failureHandler);
    }

    /*********************************************************************************/
    /*   API Standard Authentication Methods                                         */
    /*********************************************************************************/

    
    //Get the Ids of the AutheenticatedUser
    function GetBasicInfoForPerson(baseApiUri, personId, callback) {
       
        var uri = sm.portal.utility.formatString(baseApiUri + 'api/studentportal/GetBasicInfoForPerson?personId={0}', personId);
        var q = smapi.access._execRequest(uri, 'GET', null, function (container, data, textStatus, jqXHR) {
            if (callback != null) {
                callback(container, data, textStatus, jqXHR);
            }
        });
    }
    //Mailing Template Info
    function GetMailingAddressTemplateData(baseApiUri, callback) {

        var uri = sm.portal.utility.formatString(baseApiUri + 'api/studentportal/GetAddressData');
        var q = smapi.access._execRequest(uri, 'GET', null, function (container, data, textStatus, jqXHR) {
            if (callback != null) {
                callback(container, data, textStatus, jqXHR);
            }
        });
    }

    function GetIDOfAuthenticatedUser(baseApiUri, callback)
    {
     var uri = baseApiUri + 'api/Membership/GetIDOfAuthenticatedUser';
        var q = smapi.access._execRequest(uri, 'GET', null, function (container, data, textStatus, jqXHR) {
            if (callback != null) {
                callback(container, data, textStatus, jqXHR);
            }
        });
    }

    function login(baseApiUri, user, password, callback) {
       
        var uri = sm.portal.utility.formatString(baseApiUri + 'api/authentication/Login');//?username={0}&password={1}', user, password);
        var data = {
            'userName': user,
            'password': password
        };

        var q = smapi.access._execRequest(uri, 'POST', JSON.stringify(data), function (container, data, textStatus, jqXHR) {
            if (callback != null) {
                callback(container, data, textStatus, jqXHR);
            }
        });
    }

    function logout(baseApiUri, callback) {
        var uri = baseApiUri + 'api/authentication/Logout';
        var q = smapi.access._execRequest(uri, 'POST', null, function (container, data, textStatus, jqXHR) {
            if (callback != null) {
                callback(container, data, textStatus, jqXHR);
            }
        });
    }

    function userAuthenticated(baseApiUri, callback) {
        var uri = baseApiUri + 'api/authentication/AuthenticatedUser';
        var q = smapi.access._execRequest(uri, 'POST', null, function (container, data, textStatus, jqXHR) {
            if (callback) {
                callback(container, data, textStatus, jqXHR);
            }
        },
            function (data, textStatus, jqXHR) {
            // Since this function only returns a user name, we have to handle the container
            return new smapi.access.ApiContainerModel('success', data, null, null);
        });
    }

    

    function loadListItemModels(source, target, sortByText) {
        if (source == undefined) {
            return target;
        }

        for (var i = 0; i < source.length; i++) {
            target.push(new smapi.access.ListItemModel({
                Text: source[i].Text,
                Value: source[i].Value,
                ID: source[i].ID,
                GID: source[i].GID,
                FilterField1Name: source[i].FilterField1Name,
                FilterField1Value: source[i].FilterField1Value,
                FilterField2Name: source[i].FilterField2Name,
                FilterField2Value: source[i].FilterField2Value,
                IsDefault: source[i].IsDefault,
                Sequence: source[i].Sequence
            }));
        }

        if (sortByText) {
            target.sort(function (a, b) {
                return a.Text().localeCompare(b.Text());
            });
        }

        return target;
    }

    /*********************************************************************************/
    /*   API Container Models                                                        */
    /*********************************************************************************/

    // >>> API Container Model - Standard Response Container for API Requests
    // [status]: The Status of the container
    // [payload]: The content to be stored
    // [valTitle]: Validation/Error message title
    // [valMessages]: Validation/Error messages
    function ApiContainerModel(status, payload, valTitle, valMessages) {
        this.Status = status;
        this.ValidationTitle = valTitle;
        this.ValidationMessages = valMessages;
        this.Payload = payload;

        var self = this;
        return self;
    }

    // >>> API Entity Definition Model - Standard Model for Entity Schema Requests
    // [options]: Object containing model properties
    // [options.Status]: The status of the response
    // [options.ValTitle]: Validation/Error message title
    // [options.ValMessags]: Validation/Error messages
    // [options.Name]: Entity Name
    // [options.Description]: Entity Description
    // [options.GID]: Entity Guid
    // [options.Fields]: Entity Fields (collection of FieldModels)
    // [options.Relationships]: Entity Relationships (collection of RelationshipViewModel)
    // [options.Rules]: Any associated Lifecycle Rules
    function ApiEntityDefinitionModel(options) {
        var defaults = {
            Status: '',
            ValTitle: '',
            ValMessages: null,
            Name: '',
            Description: '',
            GID: null,
            Fields: null,
            Relationships: null,
            Rules: null
        };

        var settings = jQuery.extend({}, defaults, options);

        this.Container = new smapi.access.ApiContainerModel(settings.Status, settings.ValTitle, settings.ValMessages);
        this.Name = settings.Name;
        this.Description = settings.Description;
        this.GID = settings.GID;
        this.Fields = settings.Fields;
        this.Relationships = settings.Relationships;
        this.Rules = settings.Rules;

        var self = this;
        return self;

    }

    // >>> Standard Custom ViewModel Request Model
    // [options]: The collection of properties to load into the model.
    // [options.Type]: The type of item requested [Entity, List, Query]
    // [options.Namespace]: The namespace of the requested item
    // [options.Name]: The name of the requested item
    // [options.ID]: The ID of the requested item
    // [options.QueryParameters]: The list of ApiRequestQueryParameter models for parameters
    // [options.ListSortName]: The property to sort the requested list by
    // [options.LoadCollections]: The flag that determines how deep to load hierarchical items
    function ApiRequestItemModel(options) {

        var defaults = {
            Type: '',
            Namespace: '',
            Name: '',
            ResponseName: '',
            ID: 0,
            QueryParameters: [],
            ListSortName: '',
            LoadCollections: false
        };

        var settings = jQuery.extend({}, defaults, options);

        this.ItemType = settings.Type;
        this.ItemNamespace = settings.Namespace;
        this.ItemName = settings.Name;
        this.ResponseItemName = settings.ResponseName;
        this.ItemID = settings.ID;
        this.QueryParameters = settings.QueryParameters;
        this.ItemSortName = settings.ListSortName;
        this.LoadCollections = settings.LoadCollections;

        var self = this;
        return self;
    }

    // >>> Standard Custom ViewModel Response Model
    // [options]: The collection of properties to load into the model.
    // [options.Status]: String status message
    // [options.ValTitle]: Validation Response Title
    // [otpions.ValMessages]: Collection of validation/error messages
    // [options.ListData]: Generic Collection of List Data by Key and Value
    // [options.Entity]: If requested, the main Entity requested
    function ApiViewModel(options) {
        var defaults = {
            Status: '',
            ValTitle: '',
            ValMessages: null,
            ListData: null,
            Entity: null
        };

        var settings = jQuery.extend({}, defaults, options);

        this.Container = new smapi.access.ApiContainerModel(settings.Status, settings.ValTitle, settings.ValMessages);
        this.ListData = settings.ListData;
        this.Entity = settings.Entity;

        var self = this;
        return self;
    }

    // >>> Standard Parameter model for Query Item Requests
    // [options]: The collection of properties to load into the model.
    // [options.ParameterName]: The name of the requested parameter
    // [options.ParameterValue]: The value of the requested parameter
    function ApiRequestQueryParameter(options) {

        var defaults = {
            ParameterName: '',
            ParameterValue: ''
        };

        var settings = jQuery.extend({}, defaults, options);

        this.ParameterName = settings.ParameterName;
        this.ParameterValue = settings.ParameterValue;

        var self = this;
        return self;
    }

    /*********************************************************************************/
    /*   API Schema Models                                                           */
    /*********************************************************************************/

    // >>> Standard Model for Field Schema details
    // [options]: The collection of properties to load into the model.
    // [options.DataLength]: Length of the field
    // [options.DataType]: Data Type for the field
    // [options.DefaultValue]: Default value for the field
    // [options.DisplayMask]: Display mask for the field
    // [options.FieldName]: Field name
    // [options.FieldOrdinal]: Field ordinal in the parent object
    // [options.Hidden]: Flag determining hidden status
    // [options.InvalidMessage]: Message when value is invalid
    // [options.IsFixedLength]: Flag determining whether field is fixed length
    // [options.IsHtml]: Flag determining whether content is HTML
    // [options.IsNullable]: Flag determining whether the field is nullable
    // [options.IsPercentage]: Flag determining whether the field is a percentage
    // [options.Label]: The display label for the field
    // [options.MaximumValue]: Maximum value for the field
    // [options.MinimumValue]: Minimum value for the field
    // [options.Required]: Flag determining whether the field is required
    // [options.ShortLabel]: Shortened display label for the field
    // [options.Tooltip]: Display tooltip for the field
    function FieldModel(options) {
        var defaults = {
            DataLength: -1,
            DataType: 'String',
            DefaultValue: '',
            DisplayMask: '',
            FieldName: '',
            FieldOrdinal: 0,
            Hidden: false,
            InvalidMessage: '',
            IsFixedLength: false,
            IsHtml: false,
            IsNullable: false,
            IsPercentage: false,
            Label: '',
            MaximumValue: 0,
            MinimumValue: 0,
            Required: false,
            ShortLabel: '',
            Tooltip: ''
        };

        var settings = jQuery.extend({}, defaults, options);

        this.DataLength = settings.DataLength;
        this.DataType = settings.DataType;
        this.DefaultValue = settings.DefaultValue;
        this.DisplayMask = settings.DisplayMask;
        this.FieldName = settings.FieldName;
        this.FieldOrdinal = settings.FieldOrdinal;
        this.Hidden = settings.Hidden;
        this.InvalidMessage = settings.InvalidMessage;
        this.IsFixedLength = settings.IsFixedLength;
        this.IsHtml = settings.IsHtml;
        this.IsNullable = settings.IsNullable;
        this.IsPercentage = settings.IsPercentage;
        this.Label = settings.Label;
        this.MaximumValue = settings.MaximumValue;
        this.MinimumValue = settings.MinimumValue;
        this.Required = settings.Required;
        this.ShortLabel = settings.ShortLabel;
        this.Tooltip = settings.Tooltip;

        var self = this;
        return self;
    }

    // >>> Standard Model for Field Schema details
    // [options]: The collection of properties to load into the model.
    // [options.DataLength]: Length of the field
    // [options.DataType]: Data Type for the field
    // [options.AttributeName]: The underlying attribute field name
    // [options.BusinessMeaningName]: Business Meaining Name for this relationship
    // [options.ForeignKeyName]: The related table Key
    // [options.Hidden]: Flag determining hidden status
    // [options.Label]: The display label for the field
    // [options.Required]: Flag determining whether the field is required
    // [options.ShortLabel]: Shortened display label for the field
    // [options.Tooltip]: Display tooltip for the field
    // [options.RelationshipType]: The type of the relationship
    function RelationshipModel(options) {
        var defaults = {
            DataLength: -1,
            DataType: 'String',
            AttributeName: '',
            BusinessMeaningName: '',
            ForeignKeyName: '',
            Hidden: false,
            Label: '',
            Required: false,
            ShortLabel: '',
            Tooltip: '',
            RelationshipType: ''
        };

        var settings = jQuery.extend({}, defaults, options);

        this.DataLength = settings.DataLength;
        this.DataType = settings.DataType;
        this.AttributeName = settings.AttributeName;
        this.BusinessMeaningName = settings.BusinessMeaningName;
        this.ForeignKeyName = settings.ForeignKeyName;
        this.Hidden = settings.Hidden;
        this.Label = settings.Label;
        this.Required = settings.Required;
        this.ShortLabel = settings.ShortLabel;
        this.Tooltip = settings.Tooltip;
        this.RelationshipType = settings.RelationshipType;

        var self = this;
        return self;
    }

    /*********************************************************************************/
    /*   API List Models                                                             */
    /*********************************************************************************/

    // >>> Standard Model for Field Schema details
    // [options]: The collection of properties to load into the model.
    // [options.Text]: The Text of the list item
    // [options.Value]: The Value of the list item
    // [options.ID]: The ID of the underlying object
    // [options.GID]: The Guid of the underlying object
    // [options.FilterField1Value]: Filter Field 1 Value
    // [options.FilterField1Name]: Filter Field 1 Property Name
    // [options.FilterField2Value]: Filter Field 2 Value
    // [options.FilterField2Name]: Filter Field 2 Property Name
    function ListItemModel(options) {
        var defaults = {
            Text: '',
            Value: null,
            ID: null,
            GID: null,
            FilterField1Value: null,
            FilterField1Name: null,
            FilterField2Value: null,
            FilterField2Name: null,
            IsDefault: false,
            Sequence: ""
        };

        var settings = jQuery.extend({}, defaults, options);

        this.Text = ko.observable(settings.Text);
        this.Value = ko.observable(settings.Value);
        this.ID = ko.observable(settings.ID);
        this.GID = ko.observable(settings.GID);
        this.FilterField1Value = ko.observable(settings.FilterField1Value);
        this.FilterField1Name = ko.observable(settings.FilterField1Name);
        this.FilterField2Value = ko.observable(settings.FilterField2Value);
        this.FilterField2Name = ko.observable(settings.FilterField2Name);
        this.IsDefault = ko.observable(settings.IsDefault);
        this.Sequence = ko.observable(settings.Sequence);

        var self = this;
        return self;
    }

    jQuery.extend(true, smapi.access, {
        _execRequest: _execRequest,
        _formatEntitySchemaDefinition: _formatEntitySchemaDefinition,
        getEntityDefinition: getEntityDefinition,
        getEntityList: getEntityList,
        getList: getList,
        search: search,
        create: create,
        getById: getById,
        update: update,
        remove: remove,
        polyPost: polyPost,
        GetMailingAddressTemplateData: GetMailingAddressTemplateData,
        GetIDOfAuthenticatedUser: GetIDOfAuthenticatedUser,
        GetBasicInfoForPerson: GetBasicInfoForPerson,
        login: login,
        logout: logout,
        userAuthenticated: userAuthenticated,
        loadListItemModels: loadListItemModels,
        ApiContainerModel: ApiContainerModel,
        ApiEntityDefinitionModel: ApiEntityDefinitionModel,
        ApiRequestItemModel: ApiRequestItemModel,
        ApiViewModel: ApiViewModel,
        ApiRequestQueryParameter: ApiRequestQueryParameter,
        FieldModel: FieldModel,
        RelationshipModel: RelationshipModel,
        ListItemModel: ListItemModel,
    });
})(jQuery);


